<template>
    <NuxtLink to="https://simplo.cz" :class="`sim-created-by sim-created-by--${orientation}`">
        Created by
        <CoreIconSimplo :height="height" :variant="variant" />
    </NuxtLink>
</template>

<script lang="ts" setup>
import type IconSimplo from '../core/icon/IconSimplo.vue'

const {
    variant = 'light',
    orientation = 'col',
    height = 20,
} = defineProps<{
    variant?: InstanceType<typeof IconSimplo>['$props']['variant']
    orientation?: 'row' | 'col',
    height?: number,
}>()
</script>

<style lang="scss" scoped>
.sim-created-by {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    width: fit-content;
}

.sim-created-by--col {
    flex-direction: column;
}
</style>
